import {memo} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'

interface RowItemProps {
  showBeforeAfter: boolean
  label?: string
  before?: string | number | boolean
  after?: string | number | boolean
  isInfo?: boolean
  isCheckbox?: boolean
  isTextarea?: boolean
}

export const RowItem = memo((props: RowItemProps) => {
  const {label, before, after, isCheckbox, isInfo, isTextarea, showBeforeAfter} = props
  const {t} = useTranslation()

  const Before = () => {
    if (isCheckbox)
      return (
        <Form.Check
          style={{margin: isCheckbox ? '0.5rem auto' : 'auto'}}
          type='checkbox'
          defaultChecked={before as boolean}
          checked={after as boolean}
        />
      )
    return (
      <Form.Control
        style={{height: isTextarea ? '38.2px' : 'auto'}}
        as={isTextarea ? 'textarea' : undefined}
        size='sm'
        value={before as string | number}
        disabled
      />
    )
  }

  const After = () => {
    if (isCheckbox)
      return (
        <Form.Check
          style={{margin: isCheckbox ? '0.5rem auto' : 'auto'}}
          type='checkbox'
          defaultChecked={after as boolean}
          checked={after as boolean}
        />
      )
    return (
      <Form.Control
        style={{height: isTextarea ? '38.2px' : 'auto'}}
        as={isTextarea ? 'textarea' : undefined}
        size='sm'
        value={after as string | number}
        disabled
      />
    )
  }

  return (
    <Row className='mb-4'>
      <Col md={!showBeforeAfter ? 4 : 2} style={{display: 'flex', alignItems: 'center'}}>
        <div
          style={{
            marginTop: isCheckbox ? '0.5rem' : 'auto',
            marginBottom: isCheckbox ? '0.5rem' : 'auto',
          }}
        >
          {isInfo ? '' : label}
        </div>
      </Col>

      {showBeforeAfter && (
        <Col md={5}>
          {isInfo ? (
            <h5 className='text-danger'>{t('FormDetailSIP.RowItem.BEFORE')}</h5>
          ) : (
            <Before />
          )}
        </Col>
      )}

      <Col md={!showBeforeAfter ? 8 : 5}>
        {isInfo ? <h5 className='text-info'>{t('FormDetailSIP.RowItem.AFTER')}</h5> : <After />}
      </Col>
    </Row>
  )
})
